/**
 * Avatar emoji utilities
 *
 * Avatar emojis are determined by the LLM agent during character creation.
 * This module provides placeholder/helper functions only.
 *
 * For new characters: Aldric (character creation) picks the emoji
 * For existing characters: Should be set in the character data
 *
 * Special staff NPCs (Tavian, Aldric, Kira) have fixed emojis defined here.
 */

/**
 * Get avatar emoji for special staff NPCs.
 * These are the lobby innkeeper and helpers who have fixed emojis.
 * Always returns an emoji; falls back to a generic smile if unknown.
 */
export function getSpecialNpcEmoji(id: string): string {
  switch (id) {
    case 'tavian':
      return '🧙‍♂️';
    case 'aldric':
      return '🌟';
    case 'kira':
      return '⚔️';
    case 'grolt':
      return '⚒️';
    default:
      return '🙂';
  }
}
